import React from 'react'
import { domToReact } from 'html-react-parser'
import {
  Radio,
  Checkbox
} from 'antd';

export const SurveyAnswer = props => {

  const Label =  domToReact(
    props.children, 
    { 
      replace: props.replace 
    }
  )

  let Field

  switch(props.parent.parent.attribs['data-type']) {

    case 'uniq':

      Field = <Radio
        value={ props.attribs['data-value'] }
      >
        { Label }
      </Radio>

      break
    
    case 'multiple':

      Field = <Checkbox
        value={ props.attribs['data-value'] }
      >
        { Label }
      </Checkbox>

      break

    default:

      Field = <div>No type</div>

      break
  }

  return Field
}
